import React, { Component } from "react";
import { Row, Col, Card, Input, Divider, Button } from "antd";
import styled from "styled-components";
import { AiOutlineSearch } from "react-icons/all";
import { GrClose } from "react-icons/gr";
import Tab from "../../components/tab";
import { connect } from "react-redux";
import { DashboardAction } from "../../store/actions";
import TableWrapper from "../../components/Grid";
import CustomModal from "../../components/modals/customModal";
import ProfileStatus from "../../assets/images/profile_success.png";

const CreditorCard = styled(Card)`
  min-height: 300px;
  box-shadow: 0px 0px 5px 0px rgb(0 0 0 / 16%);
  margin-top: 1em;
`;
class Creditors extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isClose: false,
      isOpenModal: false,
      filters: {
        order: "asc",
        page: 1,
        per_page: 10,
        column: "email",
        totalCount: 0,
        currentCount: 0,
        total_pages: 0,
        search: "",
        status: "",
      },
      // allowed_for_credit_purchase: true,
      selectedTab: "1",
      userId: "",
      isAllow: false,
    };
  }
  componentDidMount() {
    const { getAccouts } = this.props;
    getAccouts(this.state.filters);
  }
  componentDidUpdate(preProps, preState) {
    const { getAccouts } = this.props;

    if (preProps.metaData !== this.props.metaData) {
      this.setState({
        filters: {
          ...this.state.filters,
          page: this.props?.metaData?.current_page,
          totalCount: this.props?.metaData?.total_records,
          currentCount: this.props?.metaData?.current_records,
          total_pages: this.props?.metaData?.total_pages,
        },
      });
    }
    if (
      preState.filters.page !== this.state.filters.page ||
      preState.filters.search !== this.state.filters.search ||
      preState.filters.status !== this.state.filters.status
    ) {
      getAccouts(this.state.filters); //why use this
    }
  }

  currentPage = (e) => {
    this.setState({
      filters: {
        ...this.state.filters,
        page: this.state.filters?.page + 1,
      },
    });
  };
  previousPage = (e) => {
    this.setState({
      filters: {
        ...this.state.filters,
        page: this.state.filters?.page - 1,
      },
    });
  };
  onChangeTab = (key) => {
    this.setState({
      selectedTab: key,
      filters: { ...this.state.filters, status: key === "1" ? "" : "allowed" },
    });
  };

  toggleModal = (item) => {
    this.setState({
      isOpenModal: !this.state.isOpenModal,
    });
  };

  handleModal = (userId) => {
    console.log("userId===>", userId);
    !this.state.isAllow
      ? this.props.allowCustomer(
          this.state.userId,
          () => {
            this.toggleModal();
          },
          this.state.filters
        )
      : this.props.restrictCustomer(
          this.state.userId,
          () => {
            this.toggleModal();
          },
          this.state.filters
        );
  };

  render() {
    const { isOpenModal } = this.state;
    const columns = [
      {
        title: "NAME",
        dataIndex: "name",
        align: "left",
        sortDirections: ["descend", "ascend"],
        key: "name",

        sorter: (a, b) => a.name.localeCompare(b.name),
      },
      {
        title: "EMAIL ADDRESS",
        dataIndex: "email",
        align: "left",
        key: "email",
        sorter: (a, b) => a.email.localeCompare(b.email),
      },
      {
        title: "ACTION",
        dataIndex: "action",
        align: "left",
      },
    ];
    const customerTableData = this.props.accounts?.map((item, index) => {
      return {
        key: index + 1,
        name: `${item?.user?.first_name} ${item?.user?.last_name}`,
        email: item?.user?.email,
        align: "left",
        action: (
          <Row justify="start" gutter={[10, 0]}>
            <Col>
              <Button
                onClick={() =>
                  this.setState({
                    isOpenModal: !this.state.isOpenModal,
                    userId: item.id,
                    isAllow: item?.allowed_for_credit_purchase,
                  })
                }
                type="link"
                style={{
                  color: !item?.allowed_for_credit_purchase ? "#26a69a" : "red",
                  display: "contents",
                }}
                color="black"
              >
                {!item?.allowed_for_credit_purchase ? "ALLOW" : "RESTRICT"}
              </Button>
            </Col>
          </Row>
        ),
      };
    });

    console.log("DATA===>", this.state.userId);
    const { filters } = this.state;
    return (
      <Row>
        <Col xl={24}>
          <CreditorCard>
            <Row justify="space-between" align="middle">
              <Col xl={12}>
                <h5 className="text-left">Manage Creditors</h5>
              </Col>
              {/* <Col span={6}>
                <AiOutlineSearch
                  size="25"
                  onClick={() =>
                    this.setState({ isClose: !this.state.isClose })
                  }
                /> */}

              <Col style={{ display: "flex" }}>
                <AiOutlineSearch
                  size="25"
                  onClick={() =>
                    this.setState({ isClose: !this.state.isClose })
                  }
                  className="pointer-cursor"
                />

                <Input
                  placeholder="Search..."
                  style={{
                    width: this.state.isClose ? "150px" : "0px",
                    padding: 3,
                    background: "transparent",
                    border: "none",
                    borderBottom: "none",
                  }}
                  onChange={(e) =>
                    this.setState({
                      filters: {
                        ...this.state.filters,
                        search: e.target.value,
                      },
                    })
                  }
                />
                {this.state.isClose ? (
                  <GrClose
                    size="20"
                    onClick={() =>
                      this.setState({ isClose: !this.state.isClose })
                    }
                    style={{ marginRight: "20px" }}
                    className="pointer-cursor"
                  />
                ) : null}
              </Col>
              <Divider />
            </Row>
            <Row>
              <Col xl={24}>
                <Tab
                  onChangeTab={this.onChangeTab}
                  plantData={[
                    {
                      key: "ALL CUSTOMERS",
                      component: () => (
                        <TableWrapper
                          tableColumns={columns}
                          tableData={customerTableData}
                          metaData={filters}
                          currentPage={this.currentPage}
                          previousPage={this.previousPage}
                          isLoader={this.props.allowedAccountLoading}
                          sorter={() => alert("sorter")}
                        />
                      ),
                    },
                    {
                      key: "ALLOWED CUSTOMERS",
                      component: () => (
                        <TableWrapper
                          tableColumns={columns}
                          tableData={customerTableData}
                          metaData={filters}
                          currentPage={this.currentPage}
                          previousPage={this.previousPage}
                          isLoader={this.props.allowedAccountLoading}
                        />
                      ),
                    },
                  ]}
                />
              </Col>
            </Row>
            <CustomModal
              visible={isOpenModal}
              onCancelModal={this.toggleModal}
              footer={[
                <Row justify="center">
                  <Col
                    className="d-flex justify-content-center"
                    style={{ width: "100%" }}
                  >
                    <Button
                      style={{
                        backgroundColor: "#ff9800",
                        color: "#fff",
                        width: "30%",
                        border: "none",
                      }}
                      onClick={() => this.handleModal(this.state.userId)}
                    >
                      YES
                    </Button>
                    <Button
                      style={{
                        backgroundColor: "#26a69a ",
                        color: "#fff",
                        width: "30%",
                        border: "none",
                      }}
                      onClick={() => this.toggleModal()}
                    >
                      NO
                    </Button>
                  </Col>
                </Row>,
              ]}
            >
              <Row justify="center">
                <Col className="d-flex justify-content-center">
                  <img src={ProfileStatus} />
                </Col>
                <Col>
                  <p>
                    {this.state.isAllow
                      ? "Are you sure you want to restrict credit purchases for this contractor?"
                      : "Are you sure you want to allow credit purchases for this  contractor?"}
                  </p>
                </Col>
              </Row>
            </CustomModal>
          </CreditorCard>
        </Col>
      </Row>
    );
  }
}

const mapStateToProps = (store) => {
  return {
    accounts: store.DashboardReducer.accounts,
    metaData: store.DashboardReducer.metaData,
    allowedAccountLoading: store.DashboardReducer.allowedAccount,
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    getAccouts: (params) => dispatch(DashboardAction.getAllCustomerReq(params)),
    allowCustomer: (userId, cb, params) =>
      dispatch(DashboardAction.allowCustomerReq(userId, cb, params)),
    restrictCustomer: (userId, cb, params) =>
      dispatch(DashboardAction.restrictCustomerReq(userId, cb, params)),
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(Creditors);
